import { faker } from '@faker-js/faker';
import { UserItem } from '@dynamika-shared/types/users';
import { UserRoles } from '@dynamika-shared/types/auth';

const getRandomUserRole = () => {
  const rolesArray = Object.values(UserRoles);
  const randomIndex = faker.number.int({
    min: 0,
    max: rolesArray.length - 1,
  });
  return rolesArray[randomIndex];
};

export const generateUserItem = () => ({
  id: faker.string.uuid(),
  fullName: faker.person.fullName(),
  email: faker.internet.email(),
  roles: getRandomUserRole(),
  institution: faker.lorem.word(),
  country: faker.location.country(),
  phone: faker.string.numeric(),
});

export function generateUsersList(count: number): UserItem[] {
  return faker.helpers.multiple(generateUserItem, { count });
}

export function generateRandomUsersList(count: number) {
  return generateUsersList(count);
}
